<script>
  export let name;
  import Layout from "./Layout.svelte";
</script>
<style>
</style>
<Layout id="wrapper" />
